import { addMemedLog } from '@/components/healthPlan/utils/addLog'
import { LogLevel } from '@/wrappers/logger'

const initMemedSetup = state => {
  addMemedLog(
    LogLevel.INFO,
    'Clearing memed store data, setting loading to true'
  )

  Object.assign(state, {
    memedToken: null,
    memedSetupFailed: false,
    memedSetupStatus: {
      loading: true,
      error: false
    }
  })
}

const setMemedToken = (state, memedToken) => {
  addMemedLog(LogLevel.INFO, 'Adding memed token to store')
  Object.assign(state, { memedToken })
}

const initMemedResult = (state, result) => {
  addMemedLog(LogLevel.INFO, 'Initialization process ended', { result })

  if (result.error) {
    Object.assign(state, {
      memedSetupFailed: true,
      memedSetupStatus: {
        loading: false,
        error: true
      },
      memedToken: null
    })
  } else {
    Object.assign(state, {
      memedSetupFailed: false,
      memedSetupStatus: {
        loading: false,
        error: false
      }
    })
  }
}

export default {
  initMemedSetup,
  setMemedToken,
  initMemedResult
}
